<template>
	<div>

		<div class="breadcrumb">
	    	<h1 style="color: #AC8400;">Demographic Report</h1>
	    </div>

        <!-- Breadcrumbs -->
		<div style = "padding: 10px; background-color: #F2F2F2">
			<router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Marketing</b>
      /
      <router-link :to="{name: 'survey-view'}">Survey</router-link>
      /
      <b>Report</b>

		</div>
		<!-- End of breadcrumbs -->

      <div class="separator-breadcrumb border-top"></div>
      <div class="row mb-3">
          <div class="col-12 col-lg-6 col-sm-12">
            <button class="btn btn-primary" @click="print">Print</button>
          </div>

          <div class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
              <span class="m-auto"></span>
              <div class="btn-group" role="group">
              </div>
          </div>
          
      </div>
      
			<div class="row mb-4">
				<div class="col-lg-12 col-md-12">
					<div class="card mb-4">
						<div class="card-body">
                <div id="printGraph">
                  <div class="row">
                    <div class="col-6" v-for="(chart, index) in charts" :key="index">
                      <h5>{{chart.question}}</h5>
                      <GChart
                          type = "ColumnChart"
                          :data = "chart.data"
                          :options = "columnOptions"
                      />
                      <hr>
                    </div>
                  </div>
                </div>
						</div>
					</div>
				</div>
			</div>
	  </div>

</template>

<script>
import axios from "axios"
import { GChart } from 'vue-google-charts'

export default {
  components:{
    GChart
  },

  data () {
    return {
      columnData:[],
      charts:[],

      columnOptions:{
        title: "",
        height: 500,
        width: 500,
        legend: 'bottom',
        vAxis: {title: "No. of Respondant"},
      },
    }
  },

  methods:{

    //print graph
		print() {
      // Pass the element id here
      this.$htmlToPaper('printGraph');
		},
    
    loadData() {
      let token = localStorage.getItem('token');
      let id = this.$route.params.id;
      let a = [];
      // check if has token
      if (token !== null) {
        token = JSON.parse(token)
        token = token.access_token
        
        axios.get(axios.lpsURL +'/survey_user/demographic?survey_id=' +id, {
          headers: {
            'Authorization' : 'Bearer ' + token
          }
        })
        .then(res => {
          this.charts = res.data
          console.log(JSON.stringify(this.chart))
        })
      }
    }
  },

  mounted(){
    this.loadData();
  }
}
</script>
